export const teamSectionStyle = {
  title: {
    color: 'var(--neutral-900)',
    flex: 1,
    maxWidth: '172px',
  },
  search: {
    flex: 1,
    maxWidth: '300px',
    position: 'relative',

    svg: {
      position: 'absolute',
      left: '10px',
      top: '8px',
    },

    '& .MuiFormControl-root .MuiInputBase-root input': {
      paddingLeft: '40px',

      '&::placeholder': {
        color: 'var(--neutral-500)',
      },
    },
    '& .MuiFormControl-root .MuiInputBase-root fieldset': {
      border: 0,
      background: 'var(--background-grey-op-50-1)',
    },
  },
  filterRow: {
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px',
    justifyContent: 'flex-end',
  },
  avatarHeadRow: {
    width: '70px',
  },
  roleHeadRow: {
    width: '150px',
    textAlign: 'right',
  },
  lastActiveHeadRow: {
    width: '100px',
    textAlign: 'right',
  },
  avatarBodyRow: {
    '& .MuiIconButton-root': {
      padding: '6px 0',
      marginBottom: '8px',
    },
  },

  lastActiveActive: {
    color: 'var(--success-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },
  lastActiveInvited: {
    color: 'var(--warning-600) !important',
    textAlign: 'right',
    whiteSpace: 'nowrap',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },
  lastActiveDate: {
    color: 'var(--neutral-600)',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',

      content: "'·'",
      fontSize: '23px',
    },
  },
  roleBodyRow: {
    textAlign: 'right',

    h6: {
      color: 'var(--neutral-300)',
    },

    '.MuiSelect-select': {
      padding: '8px !important',
      color: 'var(--primary-500)',
      fontSize: '14px',
    },

    '.MuiInputBase-root fieldset, .MuiInputBase-root:hover fieldset, .MuiInputBase-root.Mui-focused fieldset': {
      border: 'none',

      '&:hover': {
        border: 'none',
      },
    },
    '.MuiBox-root ': {
      marginRight: '0',
    },

    '.MuiInputBase-root svg path': {
      fill: 'var(--primary-500)',
    },
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',

    svg: {
      fill: 'var(--neutral-300)',
    },
  },
  total: {
    color: 'var(--neutral-400)',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
  menu: {
    width: '50px',

    '&.MuiTableCell-body': {
      padding: '0 5px',
    },
  },

  menuContent: {
    width: '100%',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '8px 16px',
  },

  text: {
    padding: '8px 16px',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  deleteModal: {
    '.MuiPaper-root': {
      width: '100%',
      maxWidth: '750px',
      padding: '48px 24px 48px',
    },

    '.MuiDialog-container': {
      height: '70%',
    },
  },

  createMemberModal: {
    '.MuiPaper-root': {
      width: '100%',
      maxWidth: '950px',
      height: '650px',
      padding: '48px 200px 48px',
    },
  },

  updateMemberModal: {
    '.MuiPaper-root': {
      width: '100%',
      maxWidth: '950px',
      height: 'auto',
      padding: '48px 200px 48px',
    },
  },

  name: {
    fontWeight: 'bold !important',
    fontSize: '16px !important',
  },

  email: {
    color: 'var(--neutral-300) !important',
  },

  owner: {
    color: 'var(--neutral-300) !important',
  },

  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

  loader: {
    position: 'absolute',
    left: '50%',
    top: 'calc(50% - 24px)',
  },

  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },

  tableContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    paddingTop: '40px',
    marginTop: 'auto',
  },
};
